import script from "./ControllerView.vue?vue&type=script&setup=true&lang=js"
export * from "./ControllerView.vue?vue&type=script&setup=true&lang=js"

import "./ControllerView.vue?vue&type=style&index=0&id=112767da&lang=scss"

const __exports__ = script;

export default __exports__